<div class="all-content">
  <div class="content-dimension">
    <div class="no-data" *ngIf="!isData()">
      <div class="circle">
        <i class="fas fa-exclamation"></i>
      </div>
      {{ getLanguages('errors/noData') }}
    </div>

    <div class="table-attachment" *ngIf="isData()">
      <table *ngIf="getDisplayedRows().length !== 0" mat-table [dataSource]="getDisplayedRows()" class="table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="td-80">
            <span> {{ getLanguages('attachment/name') }} </span>
          </th>
          <td mat-cell *matCellDef="let row" class="td-80">
            <span class="pointer" (click)="selectContact(row)"> {{ row.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef class="td-80">
            <span> {{ getLanguages('attachment/email') }} </span>
          </th>
          <td mat-cell *matCellDef="let row" class="td-80">
            <span> {{ row.email }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="td-20">
            <span> {{ getLanguages('attachment/action') }} </span>
          </th>
          <td mat-cell *matCellDef="let row" class="td-20">
            <button (click)="deleteContact(row.uuid)" [disabled]="!parameters.isEdit">
              <i class="fas fa-trash" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'"></i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4"></td>
        </tr>
      </table>
    </div>
    <div class="div-paginator" *ngIf="isData()">
      <div class="paginator">
        <span>
          {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
        </span>
        <button [matMenuTriggerFor]="menu" class="itens-per-page">
          {{ getItemsPerPage() }}
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="choseItemsPage(5)">5</button>
          <button mat-menu-item (click)="choseItemsPage(10)">10</button>
        </mat-menu>
        <span>
          {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
        </span>
        <span class="totalPages">
          {{ getTotalPages()}}
        </span>
        <button [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'" [disabled]="getCurrentPages() === 1"
          (click)="onPageChange(getCurrentPages() - 1, 'strategy')">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <input type="number" [ngModel]="getCurrentPages()" (blur)="checkValue()">
        <button [ngClass]="getCurrentPages() == getTotalPages() ? 'disabled-arrow' : 'arrow'"
          [disabled]="getCurrentPages() == getTotalPages()" (click)="onPageChange(getCurrentPages() + 1, 'strategy')">
          <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row row-end">
    <div class="button-upload" (click)="newContact()"
      [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
      {{ getLanguages('businessSolution/modal/contacts/new_contact') }}
    </div>
    <div class="button-upload" (click)="saveContact()" [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
      {{ getLanguages('businessSolution/modal/contacts/save_contact') }}
    </div>
  </div>

  <div class="row row-flex">
    <div class="item item-3" *ngIf="parameters?.item?.level == 3">
      <span> {{ getLanguages('businessSolution/modal/contacts/name') }} *</span>
      <input [disabled]="!parameters.isEdit" type="text" [(ngModel)]="currentContact.name">
    </div>

    <div class="item item-3" *ngIf="parameters?.item?.level == 4">
      <span>{{ getLanguages('businessSolution/modal/contacts/name') }} </span>
      <button class="select-nav" [matMenuTriggerFor]="contactMenu">
        <span>
          {{ currentContact?.name ? currentContact.name : getLanguages('search') }}
        </span>
        <i class="fas fa-caret-down"></i>
      </button>
      <mat-menu #contactMenu="matMenu">
        <div class="menu">
          <div class="input" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="searchContact" placeholder="{{ getLanguages('search') }}">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="scroll">
            <ng-container *ngFor="let contact of contactsNivel3">
              <ng-container *ngIf="contact?.name?.toLowerCase().includes(searchContact.toLowerCase())">
                <div class="item-menu" (click)="choseContact(currentContact, contact)">
                  <span [ngClass]="{'valid-span' : contact.name == (currentContact.name)}">
                    {{ contact.name }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </div>

    <div class="item item-3">
      <span> {{ getLanguages('businessSolution/modal/contacts/email') }} <span *ngIf="parameters?.item?.level == 3" >*</span></span>
      <input [disabled]="!parameters.isEdit || parameters?.item?.level == 4" type="email"
        [(ngModel)]="currentContact.email" [ngClass]="parameters?.item?.level == 4 ? 'disabled' : ''">
    </div>

    <div class="item item-3">
      <span> {{ getLanguages('businessSolution/modal/contacts/phone') }} </span>
      <input [disabled]="!parameters.isEdit || parameters?.item?.level == 4" type="text"
        [(ngModel)]="currentContact.phone" (input)="formatPhoneNumber($event)"
        [ngClass]="parameters?.item?.level == 4 ? 'disabled' : ''">
    </div>
  </div>

  <div class="row">
    <div class="item item-3">
      <span>{{ getLanguages('businessSolution/modal/contacts/area') }}</span>
      <button class="select-nav" [matMenuTriggerFor]="areaMenu"
        [disabled]="!parameters.isEdit || parameters?.item?.level == 4"
        [ngClass]="!parameters.isEdit || parameters?.item?.level == 4 ? 'disabled no-pointer' : '' ">
        <span>
          {{ currentContact?.area ? currentContact.area : getLanguages('search') }}
        </span>
        <i class="fas fa-caret-down" *ngIf="parameters.isEdit || parameters?.item?.level == 4"></i>
      </button>
      <mat-menu #areaMenu="matMenu">
        <div class="menu">
          <div class="input" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="searchArea" placeholder="{{ getLanguages('search') }}">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="scroll">
            <ng-container *ngFor="let area of areaArray">
              <ng-container *ngIf="area?.name?.toLowerCase().includes(searchArea.toLowerCase())">
                <div class="item-menu" (click)="choseArea(currentContact, area)">
                  <span [ngClass]="{'valid-span' : area.name == (currentContact.area)}">
                    {{ area.name }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </div>

    <div class="item item-3">
      <span>{{ getLanguages('businessSolution/modal/contacts/function') }}</span>
      <button class="select-nav" [matMenuTriggerFor]="functionMenu"
        [disabled]="!parameters.isEdit || parameters?.item?.level == 4"
        [ngClass]="!parameters.isEdit || parameters?.item?.level == 4 ? 'disabled no-pointer' : '' ">
        <span>
          {{ currentContact?.function ? currentContact.function : getLanguages('search') }}
        </span>
        <i class="fas fa-caret-down" *ngIf="parameters.isEdit || parameters?.item?.level == 4"></i>
      </button>
      <mat-menu #functionMenu="matMenu">
        <div class="menu">
          <div class="input" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="searchFunction" placeholder="{{ getLanguages('search') }}">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="scroll">
            <ng-container *ngFor="let function of functionArray">
              <ng-container *ngIf="function?.name?.toLowerCase().includes(searchFunction.toLowerCase())">
                <div class="item-menu" (click)="choseFunction(currentContact, function)">
                  <span [ngClass]="{'valid-span' : function.name == (currentContact.function)}">
                    {{ function.name }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </div>

    <div class="item item-3">
      <span>{{ getLanguages('businessSolution/modal/contacts/type') }}</span>
      <button class="select-nav" [matMenuTriggerFor]="contactTypeMenu"
        [disabled]="!parameters.isEdit || parameters?.item?.level == 4"
        [ngClass]="!parameters.isEdit || parameters?.item?.level == 4 ? 'disabled no-pointer' : '' ">
        <span>
          {{ currentContact?.type ? currentContact.type : getLanguages('search') }}
        </span>
        <i class="fas fa-caret-down" *ngIf="parameters.isEdit || parameters?.item?.level == 4"></i>
      </button>
      <mat-menu #contactTypeMenu="matMenu">
        <div class="menu">
          <div class="input" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="searchType" placeholder="{{ getLanguages('search') }}">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="scroll">
            <ng-container *ngFor="let type of contactTypeArray">
              <ng-container *ngIf="type?.name?.includes(searchType.toLowerCase())">
                <div class="item-menu" (click)="choseType(currentContact, type)">
                  <span [ngClass]="{'valid-span' : type.name == (currentContact.type)}">
                    {{ type.name }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
</div>
<div class="background-modals" *ngIf="createType">
  <div class="modal-create-type">
    <div class="modal-create-top">
      <div class="modal-create-toggle"></div>

      <div class="div-icon-button">
        <div class="save" (click)="setCorporationTypeContact()">
          {{ getLanguages('save')}}
        </div>
        <i class="fas fa-xmark" (click)="createType = false"></i>
      </div>
    </div>

    <div class="modal-create-row">
      <div class="modal-create-title">
        {{ getLanguages('businessSolution/modal/rules/titleNewType') }}
      </div>
    </div>

    <div class="modal-create-row">
      <div class="modal-create-item">
        <span> {{ getLanguages('businessSolution/modal/rules/titleNewType') }}</span>
        <input type="text" [(ngModel)]="newType.name">
      </div>
    </div>
  </div>
</div>